"use strict";

$(document).ready(function () {
  var page;
  var templateId = $('body').data('template');
  /*
   * Init Nette JS
   */

  $.nette.init();
  /*
  * Init page controller by template
  */

  switch (templateId) {
    case "sign":
      page = new SignController();
      break;

    case "references":
      page = new ReferencesListController();
      break;

    case "reference-add-edit":
      page = new ReferencesAddEditController();
      break;

    default:
      // init generic page controller for other templates
      page = new PageController();
      break;
  }

  var form = new FormComponent();
});